import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { featureFlagReducer } from '@surfline/web-common/dist/features';
import status from './status';
import adblock from './adblock';
import map from './map';
import spot from './spot';
import units from './units';
import animations from './animations';
import subregion from './subregion';
import user from './user';
import worldTaxonomy from './worldTaxonomy';
import components from './components';

export default combineReducers({
  adblock,
  map,
  units,
  routing: routerReducer,
  status,
  animations,
  spot,
  subregion,
  user,
  flags: featureFlagReducer,
  worldTaxonomy,
  components,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js